export const LISTAR_CNAES = "LISTAR_CNAES";
export const LISTAR_CNAES_NAO_AUTOMATIZADOS = "LISTAR_CNAES_NAO_AUTOMATIZADOS";
export const LISTAR_CNAES_FALTANTES = "LISTAR_CNAES_FALTANTES";
export const ALTERAR_TAGS = "ALTERAR_TAGS";
export const ADICIONAR_CNAE_FALTANTE = "ADICIONAR_CNAE_FALTANTE";
export const DELETAR_CNAE_FALTANTE = "DELETAR_CNAE_FALTANTE";
